<!-- APP-设备信息 -->
<template>
  <div class="md-layout">
    <!-- 主体 -->
    <div class="md-layout-item md-size-100">
      <!-- 卡片 -->
      <md-card>
        <md-card-content>
          <!-- 卡片-查询表单 -->
          <div class="md-layout card-form" style="max-width: 800px;">
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("user_id")}}</label>
                <md-input v-model="searchForm.share_sou"/>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>UID</label>
                <md-input v-model="searchForm.uid"/>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <md-table v-model="tableData">
            <!-- ID  账号 邮箱  手机 注册APP  登录时间 登录IP 注册时间 -->
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="'ID'">{{ item.node_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_snid')">{{ item.dev_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_name')">{{ item.dev_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('own_user')">{{ item.share_sou }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.node_type_name }}</md-table-cell>

              <md-table-cell :md-label="$I18n('conn_type')">{{ item.node_type ?item.conn_mode_name :"" }}</md-table-cell>
              <md-table-cell :md-label="$I18n('vendor_id')">{{ item.vendor_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_type')">{{
                item.pk_name 
                  ? item.pk_name
                  : (item.node_type ?item.dev_type_name :"")
              }}</md-table-cell>
              <md-table-cell :md-label="'UID/IP'">{{ !item.conn_mode ?item.ip :item.uid }}</md-table-cell>
              <md-table-cell :md-label="$I18n('dev_user')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('channel')">{{ item.ch_no }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')" class="button-box">
                <md-button @click="table_selected(item)" @click.stop class="md-just-icon md-round md-info left-icon">
                  <md-icon>share</md-icon>
                </md-button>
                <md-button @click="table_delete_user_product(item)" @click.stop class="md-just-icon md-round md-danger">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
        </md-card-content>
      </md-card> 
    </div>
    <!-- 弹窗-产品列表 -->
    <simple-modal ref="product" :title="modal_title" right>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div style="text-align: right;">
          <md-button @click="table_add_product" @click.stop class="md-just-icon md-round md-info">
            <md-icon>add</md-icon>
          </md-button>          
        </div>
        <!-- 表单-APP添加/修改 -->
        <md-table class="center-table" v-model="modal_table_data">
          <!-- ID  账号 邮箱  手机 注册APP  登录时间 登录IP 注册时间 -->
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('user_id')">{{ item.share_to }}</md-table-cell>
            <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('operate')" class="button-box">
              <md-button @click="table_delete_product(item)" @click.stop class="md-just-icon md-round md-danger">
                <md-icon>close</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>
        <table-page :total="modal_count" :pageSize="pageSize" v-model="modal_page_no"/>
      </template>
    </simple-modal>
    <!-- 弹窗-修改产品 -->
    <simple-modal ref="modify_product" :title="$I18n('product_manage')" @submit="modal_submit">
      <template slot="body">
        <!-- 表单-APP添加/修改 -->
        <div v-if="type=='add'">
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modal_form[item.keys]"
            :key="item.keys" v-bind="item"
          />
        </div>
        <div v-else>
          {{$I18n("check_delete", "")}}
        </div>
      </template>
    </simple-modal>
    <!-- 删除 -->
    <simple-modal ref="del_product" :title="$I18n('product_manage')" @submit="modal_delete">
      <template slot="body">
        <div>
          {{$I18n("check_delete", "")}}
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import {timestampToString} from "@/common/tools.js";
export default {
  props: ["userinfo_sys", "userinfo_database"],
  data() {
    return {
      del_modalData_id:{},
      form_modalData: [
        {
          label   : this.$I18n("share_user"),
          keys    : "to_userid",
          type    : "input",
          required: true,
        },
      ],
      modal_form  : {
        to_userid :"",
        node_id   :"",
      },
      type: "add",
      modal_title: this.$I18n("share_mng"),
      modal_data: {
        user_id: "",
        node_id: "",
      },
      modal_page_no : 1,
      modal_table_data : [],
      modal_count : 0,

      appList : [],
      searchForm : {
        share_sou:"",
        uid : "",
      },
      searchData : {
        share_sou:"",
        uid : "",
      },

      // 表格相关
      icon  : "computer",
      title : this.$I18n("device_info"),
      tableInitData : [], // 表格数据

      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: { 
    'userinfo_sys': {
      handler(){
        this.api_getModalServerData();
      }
    },
    'userinfo_database': {
      handler(){
        this.api_getModalServerData();
      },
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    modal_page_no(){
      this.api_getProduct()
    },
    currentPage(){
      this.api_getPageData()
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            let node_type_name = this.$I18n("unknow");
            let conn_mode_name = this.$I18n("unknow");
            let dev_type_name = this.$I18n("unknow");

            if(item.node_type == 0 || !item.node_type){
              node_type_name = this.$I18n("catalogue")
            } else if(item.node_type == 1){
              node_type_name = this.$I18n("gateway_1")
            } else if(item.node_type == 2){
              node_type_name = this.$I18n("equipment")
            }

            if(item.conn_mode == 0 || !item.conn_mode){
              conn_mode_name = this.$I18n("id_conn")
            } else if(item.conn_mode == 1){
              conn_mode_name = this.$I18n("catalogue")
            } else if(item.conn_mode == 2){
              conn_mode_name = "P2P"
            }

            if(item.dev_type == 1){
              dev_type_name = this.$I18n("home_camera")
            } else if(item.dev_type == 2){
              dev_type_name = this.$I18n("cellular_equipemnt")
            } else if(item.dev_type == 3){
              dev_type_name = this.$I18n("hard_video")
            } else if(item.dev_type == 4){
              dev_type_name = this.$I18n("out_video")
            } else if(item.dev_type == 5){
              dev_type_name = this.$I18n("low_power")
            } else if(item.dev_type == 6){
              dev_type_name = this.$I18n("low_power_video")
            } else if(item.dev_type == 201){
              dev_type_name = this.$I18n("wifi_n")
            }
            return {
              ...item,
              node_type_name,
              conn_mode_name,
              dev_type_name,
              create_time: item.gmt_create ?timestampToString(item.gmt_create * 1000) :"",
            }
          })
      }
    },
  },
  methods: {
    modal_delete(){
      this.$api.delAppUserProduct({
        sip : this.userinfo_database,
        node_id: this.del_modalData_id,
      })
      .then(this.$Then(() => {
        this.currentPage = 1;
        this.api_getPageData();
        this.$refs.del_product.close();
        this.$successMsg(this.$I18n("delete_success"));
      }))
      .catch(this.$Catch(this.$I18n("get_error")))
    },
    table_delete_user_product(item){
      this.del_modalData_id = item.node_id;
      this.$refs.del_product.open();
    },
    modal_submit(){
      this.$api[this.type === "add" ?"addShareProduct" :"delShareProduct"]({
        ...this.modal_form,
        sip: this.userinfo_database,
      })
        .then(this.$Then(() => {
          this.modal_page_no = 1;
          this.api_getProduct();
          this.$refs.modify_product.close();
          this.$successMsg(this.$I18n(this.type === "add" ?"edit_success" :"delete_success"));
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    table_delete_product(item){
      this.type = "delete";
      this.modal_form = {
        ...item,
        sip : this.userinfo_database,
      }
      this.$refs.modify_product.open();
    },
    table_add_product(){
      this.type = "add";
      this.modal_form = {
        sip    : this.userinfo_database,
        node_id: this.modal_data.node_id,
        to_userid: "",
      }
      this.$refs.modify_product.open();
    },
    table_selected(item){
      this.modal_page_no = 1;
      this.modal_data = {
        sip    : this.userinfo_database,
        user_id: item.user_id,
        node_id: item.node_id,
      };
      this.api_getProduct().then(this.$refs.product.open);
    },
    api_getProduct(){
      return this.$api.getShareProduct({
        ...this.modal_data,
        sip      : this.userinfo_database,
        page_no  : this.modal_page_no,
        page_size: this.pageSize,
      })
        .then(this.$Then(res => {
          this.modal_count = res.count;
          this.modal_table_data = res.data.map(item => {
            return {
              ...item,
              create_time: timestampToString(item.gmt_create * 1000),
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modal_table_data = [];
          this.modal_count = 0;
        }))
    },
    // API-表格数据
    api_getPageData(){
      this.$api.getAppUserProductList({
        ...this.searchData,
        sip      : this.userinfo_database,
        page_size: this.pageSize,
        page_no  : this.currentPage,
      })
        .then(this.$Then(res => {
          this.total = res.count
          this.tableInitData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.total = 0;
          this.tableInitData = [];
        }))
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      this.searchData = {
        sip : this.userinfo_database,
        uid : this.searchForm.uid,
        share_sou: this.searchForm.share_sou,
      };
      this.api_getPageData();
    },
  },
}
</script>
<style lang="scss" scoped>
  .canclick:hover, .canclick.selected {
    color : #26c6da;
    cursor: pointer;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 150px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 0px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
